import React from 'react'
import { useSelector } from 'react-redux'
import { KeyboardBackspace } from '@mui/icons-material'
import { sidePanelEmptyText } from '../constants'

// פאנל צד לעמוד "תוצאות הקריאה" — עמוד הסטטיסטיקות (קוראים/מתקשים פר בית ספר) בהקטנה
const StatisticsSidePanel = ({ affiliations }) => {
    const { brokenDisplay } = useSelector(state => state.general)
    const rows = affiliations?.filter(aff => aff.test_taker_execution_count)

    if (!rows?.length)
        return <div className='side-empty'>{sidePanelEmptyText}</div>

    return (
        <div>
            {rows.map(aff => {
                // אותה נוסחה כמו בעמוד הסטטיסטיקות: מעט נמוך מתחלק חצי-חצי בין קוראים למתקשים
                const expected = Math.round((aff.expected_percent || 0) * 100)
                const unexpected = 100 - expected
                const expectedCount = aff.expected_count
                const unexpectedCount = aff.test_taker_execution_count - aff.expected_count

                return (
                    <div key={aff.id} className='mini-bar-row'>
                        <div className='mini-bar-label'>
                            <span className={`mini-bar-name ${brokenDisplay && 'blurred2'}`} title={aff.name}>{aff.name}</span>
                            <KeyboardBackspace sx={{ fontSize: 13, color: '#94a3b8', flexShrink: 0 }} />
                        </div>
                        <div className='mini-bar-content'>
                            <div className='mini-bar-caption'>
                                {'תוצאות של '}
                                <b className={`${brokenDisplay && 'blurred2'}`}>{aff.test_taker_execution_count}</b>
                                {' תלמידים'}
                            </div>
                            <div className='mini-bar-track'>
                                {expected > 0 &&
                                    <div className='mini-bar-expected' style={{ width: `${expected}%` }}>
                                        {expected > 12 && <>{`${expected}% (`}<span className={`${brokenDisplay && 'blurred2'}`}>{expectedCount}</span>{' תלמידים)'}</>}
                                    </div>}
                                {unexpected > 0 &&
                                    <div className='mini-bar-unexpected' style={{ width: `${unexpected}%` }}>
                                        {unexpected > 12 && <>{`${unexpected}% (`}<span className={`${brokenDisplay && 'blurred2'}`}>{unexpectedCount}</span>{' תלמידים)'}</>}
                                    </div>}
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default StatisticsSidePanel
